import { Base } from "./Base";
import { EntityFieldReader } from "./FieldReader";
var EntitySerializer = (function () {
    function EntitySerializer(instance) {
        this.instance = instance;
    }
    EntitySerializer.prototype.pick = function () {
        var _this = this;
        var fields = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            fields[_i] = arguments[_i];
        }
        return fields.reduce(function (picked, key) {
            picked[key] = _this.instance[key];
            return picked;
        }, {});
    };
    EntitySerializer.prototype.mapOut = function (target) {
        var fields = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            fields[_i - 1] = arguments[_i];
        }
        return this.performMapOut(target, fields);
    };
    EntitySerializer.prototype.mapOutRaw = function () {
        var fields = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            fields[_i] = arguments[_i];
        }
        return this.performMapOut({}, fields);
    };
    EntitySerializer.prototype.performMapOut = function (target, mappings) {
        var instance = this.instance;
        mappings.forEach(function (mapping) {
            if (isSameTypeMap(mapping)) {
                target[mapping] = instance[mapping];
            }
            else if (isDirectMap(mapping)) {
                var field = mapping.field, map = mapping.map;
                target[field] = map(instance[field]);
            }
            else if (isIndirectMap(mapping)) {
                var map = mapping.map, from = mapping.from;
                var mapper = map.with, to = map.to;
                target[to] = mapper(instance[from]);
            }
        });
        return target;
    };
    EntitySerializer.prototype.asJSON = function () {
        var _this = this;
        return new EntityFieldReader(this.instance)
            .onlySet()
            .reduce(function (json, f) {
            var value = _this.instance[f.name];
            if (hasAsJSONMethod(value)) {
                value = deserializeSingle(value);
            }
            else if (f.fieldArrayLike && value) {
                value = value.map(deserializeSingle);
            }
            json[f.name] = value;
            return json;
        }, {});
    };
    return EntitySerializer;
}());
export { EntitySerializer };
function isSameTypeMap(f) {
    return typeof f === "string";
}
function isDirectMap(f) {
    return "field" in f && "map" in f;
}
function isIndirectMap(f) {
    return "from" in f && "map" in f;
}
function canBeConvertedToJson(v) {
    return v && v instanceof Base;
}
function hasAsJSONMethod(v) {
    return v && typeof v === "object" && "asJSON" in v;
}
var deserializeSingle = function (v) {
    if (hasAsJSONMethod(v)) {
        v = v.asJSON();
    }
    else if (canBeConvertedToJson(v)) {
        v = v.serialize().asJSON();
    }
    return v;
};
